<template>
  <label
    :class='{
      "is-disabled": isDisabled
    }'
  >
    <input
      type='checkbox'
      :checked='isChecked || isDisabled'
      :disabled='isDisabled'
      @input='isDisabled ? null : emit("update:isChecked", $event.target.checked)'
    >
    <span class='checkmark'><CheckmarkIcon v-if='isChecked' /></span>
    <span class='content'>
      {{ label }}<slot />
    </span>
  </label>
</template>

<script setup>
import CheckmarkIcon from '@/../images/vue/components/checkbox/checkmark_v4.svg?inline';

defineProps({
  isChecked: { type: Boolean, required: true },
  isDisabled: { type: Boolean, required: false, default: false },
  label: { type: String, required: false, default: undefined }
});
const emit = defineEmits(['update:isChecked']);
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/ltr_rtl'
@import 'app/packs/stylesheets/mixins/responsive'

label
  align-items: center
  display: flex

  &:not(.is-disabled)
    cursor: pointer

input
  display: none

  &:checked + span.checkmark
    color: #fff

    &:before
      background: var(--text-strong)

  &:disabled + span.checkmark
    color: #d0d5dd

    &:before
      background: var(--gray-50)

span.checkmark
  align-items: center
  display: inline-flex
  flex-shrink: 0
  justify-content: center
  position: relative

  +lte_ipad
    height: rem4(16px)
    width: rem4(16px)

  +gte_laptop
    height: 16px
    width: 16px

  &:before
    background: #fff
    border: 1px solid var(--gray-400)
    box-sizing: border-box
    content: ''
    left: 0
    position: absolute
    top: 0
    transition: background var(--transition-duration), border-color var(--transition-duration)

    +lte_ipad
      border-radius: rem4(4px)
      height: rem4(16px)
      width: rem4(16px)

    +gte_laptop
      border-radius: 4px
      height: 16px
      width: 16px

svg
  position: relative
  z-index: 1

  +lte_ipad
    height: rem4(12px)
    width: rem4(12px)

  +gte_laptop
    height: 12px
    width: 12px

span.content
  align-items: baseline
  display: inline-flex
  user-select: none
  gap: inherit // apply gap from styles of parent not if such is set

  +gte_laptop
    white-space: nowrap
</style>
